import { Alert, AlertTitle, Button } from '@mui/material';
import { PADDLE_CONNECT_TEST_IDS } from '@modules/paddle-connect/testIds';

/** Reuses the integration card's themed alert/action pattern. */
export function PaddleConnectionError({ error, hasVerifiedStatus, onRetry }: {
  error?: string | null;
  hasVerifiedStatus: boolean;
  onRetry: () => void;
}) {
  return (
    <Alert severity="warning" data-testid={PADDLE_CONNECT_TEST_IDS.connectionError} sx={{ mb: 2 }}
      action={<Button color="inherit" size="small" onClick={onRetry}
        data-testid={PADDLE_CONNECT_TEST_IDS.checkStatus}>Check again</Button>}>
      <AlertTitle>Could not verify Paddle connection</AlertTitle>
      {error || 'Connection status is unavailable.'}
      {' '}{hasVerifiedStatus ? 'Showing the last verified status.' : 'Check again before connecting an account.'}
    </Alert>
  );
}
